import { render, staticRenderFns } from "./ServicePointDetailPage.vue?vue&type=template&id=7cb8f475&"
import script from "./ServicePointDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ServicePointDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointDetailPage.vue?vue&type=style&index=0&id=7cb8f475&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports